import { render } from "./DownloadAppView.vue?vue&type=template&id=94a91772&scoped=true"
import script from "./DownloadAppView.vue?vue&type=script&lang=js"
export * from "./DownloadAppView.vue?vue&type=script&lang=js"

import "./DownloadAppView.vue?vue&type=style&index=0&id=94a91772&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a91772"]])

export default __exports__